<template>
	<div v-for="processingTechnique in processingTechniquesData" :key="processingTechnique.id" class="pt-info">
		<p class="name mb-2">{{ processingTechnique.processingTechnique.name }} </p>
		<p class="mb-4 text-sm italic text-neutral-400" v-if="processingTechnique.processingTechnique.description">
			{{ processingTechnique.processingTechnique.description }}
		</p>
		<div class="flex items-center justify-between flex-wrap">
			<div class="w-full" v-if="processingTechnique.processingTechnique.category">
				<p class="label">Category</p>
				<p class="value"> {{ processingTechnique.processingTechnique.category }}</p>
			</div>
		</div>
		<AssetProcessingTechniqueProperties 
			:asset-processing-technique-id="processingTechnique.id" 
			:asset-processing-technique-properties="processingTechnique.assetProcessingTechniqueProperties"
			:processing-technique-id="processingTechnique.processingTechnique.id"
		/>
	</div>
</template>
<script setup lang="ts">
import { AssetProcessingTechniqueInterface } from '@/models/assetAssessmentInterfaces';
import { defineProps} from 'vue';
import AssetProcessingTechniqueProperties from './AssetProcessingTechniqueProperties.vue';

defineProps<{
	processingTechniquesData: AssetProcessingTechniqueInterface[];
}>()



</script>